


























































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import {
  PreCollection,
  PreCollectionContentType,
  PreCollectionCoupon,
} from '@/resource/pre-collection/pre-collection.model';
import getLevelPremadePaper from '@/utils/common/get-level-premade-paper';
import { copyPreCollectionByUuid } from '@/utils/pre-collection/pre-collection-util';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import PreCollectionPdfOnly from '@/components/modals/ModalPreCollectionPdfOnly.vue';
import ModalRegister from '@/components/modals/ModalRegister.vue';
import ModalReview from '@/components/modals/ModalReview.vue';
import ModalCareer from '@/components/modals/ModalCareer.vue';
import { ErrorResponse } from '@/utils/response';
import MainButton from '@/main-components/common/MainButton.vue';
import Adsense from '@/main-components/adsense/Adsense.vue';
import cookie, {
  COOKIE,
  COOKIE_EXPIRATION,
  getUserStatus,
  getUserReviewed,
} from '@/utils/cookie';
import { UserStatus } from '@/resource/user/user.model';
import PurchaseStore, {
  PurchaseStoreInterface,
} from '@/resource/purchase/purchase.store';

@Component({
  components: {
    BeatLoader,
    PreCollectionPdfOnly,
    ModalRegister,
    ModalReview,
    ModalCareer,
    MainButton,
    Adsense,
  },
})
export default class PreCollectionDetail extends Vue {
  @Prop({ required: true })
  currentPreCollection!: PreCollection;

  @Prop({ required: true })
  createPdfByCollection!: () => Promise<Blob>;

  @Prop({ required: true })
  createPdfByPaperGenerated!: () => Promise<Blob>;

  @Prop({ default: true })
  isPreviewOnly!: boolean;

  @Prop({ default: true })
  isLoggedin!: boolean;

  @Prop({ default: null })
  promoCode: string | null;

  @Inject('openPremiumPlanModal')
  openPremiumPlanModal!: () => void;

  @Inject('openRegisterModal')
  openRegisterModal!: () => void;

  @Prop({ required: true })
  isDetailLoading!: boolean;

  @Prop({ required: true })
  pdfDownloaded: number;

  @Prop({ required: true })
  isCourse: boolean;

  @Prop({ required: true })
  fetchPdfDownloaded: () => void;

  // Modal ------------------------

  openReviewModal: any = null;
  openCareerModal: any = null;

  openModalReview(openModal: any) {
    this.openReviewModal = openModal;
  }

  openModalCareer(openModal: any) {
    this.openCareerModal = openModal;
  }

  // -----------------------------

  isDownloadPdfLoading = false;
  isCopyCollectionLoading = false;
  showPdfOnlyModal = false;
  showRegister = false;

  appliedCoupon: PreCollectionCoupon | null = null;
  couponInput = '';
  showCouponInput = false;

  purchaseStore: PurchaseStoreInterface = PurchaseStore;

  get level() {
    return getLevelPremadePaper(
      this.currentPreCollection ? this.currentPreCollection.form : 0,
    );
  }

  get mainButtonLabel() {
    const mainText = this.currentPreCollection.course
      ? 'Daftar Course'
      : 'Download PDF';

    return this.hasPrice && this.appliedCoupon
      ? this.precollectonPrice !== this.precollectonOrignalPrice
        ? mainText +
          ` (RM ${this.precollectonPrice} <span class="line-through">${this.precollectonOrignalPrice}</span>)`
        : mainText + ` (RM ${this.precollectonPrice})`
      : this.hasPrice
      ? mainText + ` (RM ${this.precollectonPrice})`
      : mainText;
  }

  get isPdfOnly() {
    return this.currentPreCollection.collection ? false : true;
  }

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get isPremiumStatus() {
    return this.userStatus === UserStatus.Premium;
  }

  get userHasReviewed() {
    return getUserReviewed();
  }

  get precollectonPrice() {
    const price =
      (this.currentPreCollection.price &&
        parseInt(this.currentPreCollection.price)) ||
      0;

    if (this.appliedCoupon) {
      return (price - price * this.appliedCoupon.discount).toFixed(2);
    } else {
      return price.toFixed(2);
    }
  }

  get precollectonOrignalPrice() {
    return (
      this.currentPreCollection.price &&
      parseInt(this.currentPreCollection.price) &&
      parseInt(this.currentPreCollection.price).toFixed(2)
    );
  }

  get hasPrice() {
    return (
      this.currentPreCollection.price && this.currentPreCollection.price !== '0'
    );
  }

  created() {
    if (this.promoCode && this.hasPrice) {
      this.showCouponInput = true;
      this.couponInput = this.promoCode;
      this.applyCoupon();
    }
  }

  async downloadPdfClick() {
    if (!this.isLoggedin) {
      this.$sendMpEvent({ event: this.$mp_value.PremadePaperRegister });
      this.openRegisterModal && this.openRegisterModal();
      return;
    }

    // To open premium plan modal if the collection is premium
    // if (this.isPreviewOnly) {
    //   this.openPremiumPlanModal && this.openPremiumPlanModal();
    //   return;
    // }

    if (!this.isPremiumStatus && !this.hasPrice) {
      if (this.currentPreCollection.course) {
        this.$sendMpEvent({
          event: this.$mp_value.CourseBecomePremium,
          properties: {
            uuid: this.currentPreCollection.uuid,
            name: this.currentPreCollection.name,
            form: this.currentPreCollection.form,
            type: this.currentPreCollection.type,
            year: this.currentPreCollection.year,
            subjectUuid: this.currentPreCollection.subject.uuid,
            isPremium: this.currentPreCollection.isPremium,
            isMainButton: true,
            contentType: PreCollectionContentType.Course,
          },
        });
      } else {
        this.$sendMpEvent({
          event: this.$mp_value.PremadePaperLimitHit,
          properties: {
            uuid: this.currentPreCollection.uuid,
            name: this.currentPreCollection.name,
            form: this.currentPreCollection.form,
            type: this.currentPreCollection.type,
            year: this.currentPreCollection.year,
            subjectUuid: this.currentPreCollection.subject.uuid,
            isPremium: this.currentPreCollection.isPremium,
            isMainButton: true,
            contentType: this.currentPreCollection.course
              ? PreCollectionContentType.Course
              : this.currentPreCollection.pdfLink
              ? PreCollectionContentType.Pdf
              : this.currentPreCollection.collection
              ? PreCollectionContentType.Collection
              : PreCollectionContentType.PaperGenerated,
          },
        });
      }

      this.openPremiumPlanModal && this.openPremiumPlanModal();
      return;
    }

    if (
      this.isDetailLoading ||
      this.isDownloadPdfLoading ||
      this.isCopyCollectionLoading
    )
      return;

    this.isDownloadPdfLoading = true;
    this.$emit('updateIsDetailLoading', true);

    if (this.currentPreCollection.course) {
      if (this.hasPrice) {
        const data: any = await this.purchaseStore.createPurchaseCheckout({
          precollectionUuid: this.currentPreCollection.uuid,
          coupon: this.appliedCoupon ? this.appliedCoupon.name : '',
        });

        const checkoutUrl = data && data.data && data.data.checkoutUrl;

        if (checkoutUrl) {
          window.location.assign(checkoutUrl);
        }
      } else {
        await this.purchaseStore.createPurchase(this.currentPreCollection.uuid);

        this.$toasted.global.mainToast({
          message: 'Purchase Successful',
        });

        this.$sendMpEvent({
          event: this.$mp_value.CoursePurchase,
          properties: {
            uuid: this.currentPreCollection.uuid,
            name: this.currentPreCollection.name,
            form: this.currentPreCollection.form,
            type: this.currentPreCollection.type,
            year: this.currentPreCollection.year,
            subjectUuid: this.currentPreCollection.subject.uuid,
            isPremium: this.currentPreCollection.isPremium,
            contentType: PreCollectionContentType.Course,
          },
        });

        window.location.reload();
      }
    } else {
      this.$timeMpEvent(this.$mp_value.LoadTimeDownloadPdf);

      const collectionName = `${this.currentPreCollection.subject.name}_${this.currentPreCollection.name}_${this.currentPreCollection.year}.pdf`;
      collectionName.replaceAll(' ', '_');

      let blob: Blob | null = null;

      try {
        if (this.currentPreCollection.pdfLink) {
          blob = await fetch(this.currentPreCollection.pdfLink).then(r =>
            r.blob(),
          );
        } else if (this.currentPreCollection.collection) {
          blob = await this.createPdfByCollection();
        } else if (this.currentPreCollection.paperGenerated) {
          blob = await this.createPdfByPaperGenerated();
        }
        //
      } catch (err) {
        const error: ErrorResponse = err as any;
        this.$toasted.global.mainToast({
          message: `ERROR: ${error.message}`,
        });
      }

      const url = window.URL.createObjectURL(blob as Blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', collectionName);
      document.body.appendChild(link);
      link.click();

      this.$toasted.global.mainToast({
        message: 'PDF paper downloaded',
      });

      if (!this.isPremiumStatus) {
        this.openPremiumPlanModal && this.openPremiumPlanModal();
      }

      // Update downloaded paper
      const updateDownloadPdf = this.pdfDownloaded + 1;

      cookie.set(COOKIE.PDF_DOWNLOADED, updateDownloadPdf.toString(), {
        sameSite: 'strict',
        expires: COOKIE_EXPIRATION,
      });

      this.$sendMpEvent({
        event: this.$mp_value.PremadePaperDownload,
        properties: {
          uuid: this.currentPreCollection.uuid,
          name: this.currentPreCollection.name,
          form: this.currentPreCollection.form,
          type: this.currentPreCollection.type,
          year: this.currentPreCollection.year,
          subjectUuid: this.currentPreCollection.subject.uuid,
          isPremium: this.currentPreCollection.isPremium,
          contentType: this.currentPreCollection.pdfLink
            ? PreCollectionContentType.Pdf
            : this.currentPreCollection.collection
            ? PreCollectionContentType.Collection
            : PreCollectionContentType.PaperGenerated,
        },
      });

      this.$sendMpEvent({
        event: this.$mp_value.LoadTimeDownloadPdf,
        properties: {
          contentType: this.currentPreCollection.pdfLink
            ? PreCollectionContentType.Pdf
            : this.currentPreCollection.collection
            ? PreCollectionContentType.Collection
            : PreCollectionContentType.PaperGenerated,
        },
      });
    }

    this.isDownloadPdfLoading = false;
    this.$emit('updateIsDetailLoading', false);
    this.fetchPdfDownloaded();

    // Modal Customer Review for premium user
    if (this.userHasReviewed) return;
    if (this.isPremiumStatus) {
      this.openReviewModal && this.openReviewModal();
      this.$sendMpEvent({ event: this.$mp_value.ReviewModalOpen });
    }
  }

  async copyAsCollection() {
    if (!this.isLoggedin) {
      this.showRegister = true;
      return;
    }

    if (this.isPdfOnly) {
      this.showPdfOnlyModal = true;
      return;
    }

    if (
      this.isDetailLoading ||
      this.isDownloadPdfLoading ||
      this.isCopyCollectionLoading
    )
      return;

    this.isCopyCollectionLoading = true;
    this.$emit('updateIsDetailLoading', true);

    try {
      const newCollection = await copyPreCollectionByUuid(
        this.currentPreCollection.uuid,
      );

      this.$router.push({ path: `/collections/${newCollection.uuid}` });
    } catch (err) {
      const error: ErrorResponse = err as any;
      this.$toasted.global.mainToast({
        message: `ERROR: ${error.message}`,
      });
    }

    this.$router;

    this.isCopyCollectionLoading = false;
    this.$emit('updateIsDetailLoading', false);
  }

  applyCoupon() {
    let selectedCoupon: PreCollectionCoupon | null | undefined = null;
    if (
      this.couponInput &&
      this.currentPreCollection.coupons &&
      this.currentPreCollection.coupons.length
    ) {
      selectedCoupon = this.currentPreCollection.coupons.find(
        c => c.name.toLowerCase() === this.couponInput.trim().toLowerCase(),
      );
    }

    if (selectedCoupon) {
      // this.$toasted.global.mainToast({
      //   message: 'promo digunakan 🥳',
      // });
      this.appliedCoupon = selectedCoupon;
    } else {
      this.$toasted.global.mainToast({
        message: 'kod promosi tidak boleh diguna 🛑',
      });
      this.appliedCoupon = null;
    }
  }

  closePdfOnlyModal() {
    this.showPdfOnlyModal = false;
  }

  closeRegister() {
    this.showRegister = false;
  }

  toggleCouponInput() {
    this.showCouponInput = !this.showCouponInput;
  }
}
